/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import {useEffect, useState, useRef} from 'react';
import GlobalStyle, { AppWrapper, Container } from './_styles';
import Breadcrumb from './images/breadcrumb.svg';
import ReactLoading from "react-loading"; // TODO: Don't use this library? Do it ourselves?
import axios from 'axios'

function getDefaultPath()
{
	// Read the default path to open from the URL ("10.0.0.1/?path=...")
	const currentQuery = new URLSearchParams(window.location.search);
	const defaultPath = currentQuery.get('path');
	if (defaultPath === null)
		return "/";
	return defaultPath;
}

function formatSize(bytes)
{
	if (isNaN(bytes))
		return bytes;

	if (bytes == 0)
		return "0 B";

	const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	var i = Math.floor(Math.log(bytes) / Math.log(1024));
	if (i >= units.length)
		i = units.length - 1;

	return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${units[i]}`;		
}

function getProgress(done, total)
{
	if (isNaN(done) || done == 0 || isNaN(total) || total == 0)
		return "0%";

	return `${Math.round((done * 100) / total)}%`;		
}

const defaultPath = getDefaultPath();
var hintTimer = null;

App.propTypes = {
	propArray: PropTypes.array.isRequired,
	propBool: PropTypes.bool.isRequired,
	propFunc: PropTypes.func,
	propNumber: PropTypes.number,
	propString: PropTypes.string,
	propObject: PropTypes.object
  }

function App() {

	const [ path, setPath ] = useState(defaultPath);

	const [ popupCreateFolder, setPopupCreateFolder ] = useState(false);
	const [ popupUploadFile, setPopupUploadFile ] = useState(false);
	const [ popupDeleteFolder, setPopupDeleteFolder ] = useState(false);
	const [ popupDeleteFile, setPopupDeleteFile ] = useState(false);
	const [ popupError, setPopupError ] = useState(false);
	const [ popupExistingFile, setPopupExistingFile ] = useState(false);

	const [ loading, setLoading ] = useState(true);
	const [ active, setActive ] = useState(0);
	const [ list, setList ] = useState([]);
	const [ activePlay, setActivePlay ] = useState(-1);
	const [ deviceName, setDeviceName ] = useState("");
	const [ currentError, setCurrentError ] = useState("Error text not set");
	const [ mkdirPath, setMkdirPath ] = useState("");
	const [ hint, setHint ] = useState("");

	const [checkedState, setCheckedState] = useState(
		new Array(list.length).fill(false)
	);

	const [ uploadInput, setUploadInput ] = useState(null);
	const [ uploadSizeDone, setUploadSizeDone ] = useState(0);
	const [ uploadSizeTotal, setUploadSizeTotal ] = useState(1);
	const [ uploadFileName, setUploadFileName ] = useState("");
	const controllerRef = useRef(null);
	const uploadListRef = useRef(new Map());

	const handleOnChangeQueue = (position) => {
		const updatedCheckedState = checkedState.map((item, index) =>
			index === position ? !item : item
		);

		setCheckedState(updatedCheckedState);
		console.log(position);
	};

	function onCreateFolderClick()
	{
		if (mkdirPath === "")
			return;
		if (list.find(item => item.name == mkdirPath))
		{
			const element = document.getElementById("mkdirTextInput");
			element.setAttribute("disabled", true);
			element.value = "Folder already exists...";
			clearTimeout(hintTimer);
			hintTimer = setTimeout(function() { 
				element.value = mkdirPath; 
				element.removeAttribute("disabled");
			}, 1500);
			return;
		}
		mkdir();
		setPopupCreateFolder(false);
	}

	function mkdir()
	{
		const doFetch = async () => {
			const response = await fetch(encodeURI('/mounts' + path + mkdirPath), { method: "MKCOL" })
			if (! response.ok) {
				setCurrentError("Failed to create folder!");
				setPopupError(true);
				navigate("/");
			}
			else {
				setMkdirPath("");
				refreshListing();
			}
		}
		setLoading(true);
		doFetch();
	}

	function startUpload(file)
	{
		const doFetch = async () => {
			uploadListRef.current.set(file.name, 0);
			const uploadConfig = {
				headers: { "Content-Type": "multipart/form-data" },
				signal: controllerRef.current.signal,
				onUploadProgress: function(progressEvent) {
					const increment = progressEvent.loaded - uploadListRef.current.get(file.name);
					uploadListRef.current.set(file.name, progressEvent.loaded);
					setUploadSizeDone(prev => prev + increment);
				}
			};

			const url = encodeURI('/mounts' + path + file.name);

			axios.put(url, file, uploadConfig)
				.catch((error) => {
					if (error.response){
						console.log(`The request was made and the server responded with a status code - ${error.response.status}!`);
						if (error.response.status == 507)
							setCurrentError("Upload was aborted - insufficient space on device!");
						else
							setCurrentError(`Upload was aborted - status code ${error.response.status}!`);
						setPopupError(true);
					}
					else {
						console.log(`Upload was aborted - ${error.message}!`);
					}
					axios.delete(url);
				})
				.finally(() => {
					uploadListRef.current.delete(file.name);
					if (! uploadListRef.current.size) {
						controllerRef.current = null;
						setPopupUploadFile(false);
					}
					refreshListing();
				});
		}
		setPopupUploadFile(true);
		doFetch();
	}

	function deleteItem(item)
	{
		const doFetch = async () => {
			const response = await fetch(encodeURI('/mounts' + path + item.name), { method: "DELETE" })
			if (! response.ok) {
				console.log("Failed to delete file!")
				setCurrentError("Failed to delete file!");
				setPopupError(true);
				navigate("/");
			}
			else
			{
				refreshListing();
			}
		}
		setLoading(true);
		doFetch();
	}

	function refreshListing()
	{
		const doFetch = async () => {
			const response = await fetch(encodeURI('/mounts' + path))
			// if we fail to get a response (i.e. get a 404) fallback to the nearest working path
			if (! response.ok) {
				let searchPath = path;
				while (searchPath !== "")
				{
					const splitIndex = searchPath.lastIndexOf("/");
					searchPath = splitIndex === -1 ? "" : searchPath.slice(0, splitIndex);
					// since we 'slice away' the '/' we need to append when making a query
					const existsResponse = await fetch(encodeURI('/mounts' + searchPath + "/"));
					if (existsResponse.ok)
					{
						break;
					}
				}
				searchPath += "/";
				navigate(searchPath);
				return
			}

			const data = await response.json()
			const settings = (await (await fetch('/admin/api/v1/setupBasic')).json()).response;
			setLoading(false);
			setList(data);
			setDeviceName(settings.deviceName);
		}
		setLoading(true);
		doFetch();
	}

	function onUploadInput(event)
	{
		const files = event.target.files;
		for (let i = 0; i < files.length; i++) 
		{
			if (list.find(item => item.name == files[i].name))
			{
				setUploadInput(event.target);
				setPopupExistingFile(true);
				return;
			}
		}
		processUploadInput(event.target);
	}

	function processUploadInput(input)
	{
		const maxFileNameLength = 20;
		const files = input.files;
		if (files.length == 1)
			setUploadFileName(files[0].name.substring(0, maxFileNameLength));
		else
			setUploadFileName(`${files.length} files`);

		if (controllerRef.current) {
			console.log("Unexpected reference to AbortController detected - calling abort()!")
			controllerRef.current.abort();
		}
		controllerRef.current = new AbortController();
		uploadListRef.current.clear();

		let totalSize = 0;
		for (let i = 0; i < files.length; i++)
			totalSize += files[i].size;

		setUploadSizeDone(0);
		setUploadSizeTotal(totalSize);
		console.log(`To be uploaded: ${formatSize(totalSize)}`);

		for (let i = 0; i < files.length; i++) {
			startUpload(files[i]);
		}
		resetUploadInput(input);
	}

	function resetUploadInput(input)
	{
		input.value = null;
		setPopupExistingFile(false);
	}

	function makeHref(newPath)
	{
		return newPath === "/" ? "/" : "?path=" + encodeURIComponent(newPath);
	}

	function navigate(newPath)
	{
		if (path !== newPath)
		{
			window.history.pushState(newPath, "", makeHref(newPath));
			setPath(newPath);
			setActivePlay(-1);
			setActive(-1);

			console.log("navigated to:", newPath);
		}
	}

	function onItemClicked(itemType, index)
	{
		if (itemType.type === 'directory')
		{
			let newPath = path + itemType.name + "/";
			navigate(newPath);
		}

		setActive(index);
	}

	// Temporary function, just to set a active class in a media type item.
	function onPlayMedia(itemType, index)
	{
		if (itemType.type === 'media')
		{
			setActivePlay(index);
		}
	}

	function renderBreadcrumbs()
	{
		let breadcrumbs = [];

		let homeClassName = 'active';
		if (path === '/')
			homeClassName = 'current';

		breadcrumbs.push(
			<>
				<span onClick={()=> { navigate("/") } }
				className={homeClassName}>Home</span>
			</>
		);

		let parts = path.split("/").filter(part => (part.length > 0));

		parts.forEach(
			(pathPart, i, pathFull) => {
				let className = 'active';
				if (i === parts.length - 1)
					className = 'current';
				breadcrumbs.push(
					<>
						<div className="breadcrumb"></div>
						<span className={className} 
							onClick=
							{ ()=> {
								let newPath = "/" + pathFull.slice(0, i+1).join("/") + "/";
								navigate(newPath);
							} }>{pathPart}
						</span>
					</>
				);
			}
		)

		return breadcrumbs;
	}

	function renderButtonContainer()
	{
		if (path !== "/")
		{
			return <>
				<div className="buttons-container">
				<div className="btn-upload">
				<input className="input" type="file" id="file" name="file" onInput={onUploadInput} multiple/>
				</div>
				<div className="btn-create-folder" onClick={()=> setPopupCreateFolder(!popupCreateFolder)}>Create Folder</div>
				</div>
			</>
		}
	}

	// When the path is changed, we must re-fetch the directory listing.
	useEffect(refreshListing, [path]);

	// Whenever the history state changes, refresh the path.
	useEffect(() => {
		const listener = e => setPath(e.state == null ? defaultPath : e.state);
		window.addEventListener("popstate", listener);
		return () => window.removeEventListener("popstate", listener);

	}, []);

	return (
		<>
			<GlobalStyle />
			<AppWrapper>
				<Container completed = {getProgress(uploadSizeDone, uploadSizeTotal)}>
					{/* Header */}
					<div className="header">
						<h1>{deviceName}</h1>
						<div className="logo"></div>
					</div>

					<div className="top-bar">
						<div className="breadcrumb-container">
							{renderBreadcrumbs()}
						</div>

						{renderButtonContainer()}
					</div>

					{/* HERE! {path} has been removed just to test the breadcrumb with arrow style */}

					{/* <div className="btn-container"></div> */}

					<div className="content">
						<div className="mini-header">
							<span>Name</span>
							<span>File Size</span>
							<span>Created</span>
						</div>

						{loading ? <ReactLoading type="spin" className="spinner" style={{}}/> : list.map((item, i) => (
							<div key={i} className={"item " + (activePlay === i ? 'active' : '')} onClick={() => onItemClicked(item, i)}>
								<div>
									{/* Media Type */}
									{
										item.type === 'file' &&
										<div className={`icons-type txt`}/>
									}
									{
										item.type === 'directory' &&
										<div className={`icons-type folder`}/>
									}
									{
										item.type === 'media' &&
										<div className={`icons-type mov ${activePlay === i ? 'active' : ''}`}/>
									}

									{/* Name */}
									<span>
										{item.name}
									</span>
								</div>

								{/* File Size */}
								<div>
									<span>{formatSize(item.size)}</span>
								</div>

								{/* Created */}
								<div>
									<span>
										{item.mtime}
									</span>

									{/* Actions */}
									<div className="icons-action">
										{ item.type === "file" && <a className="download" href={encodeURI('/mounts' + path + item.name)} download={item.name}>.</a> }
										{ item.type === "media" && <a className="download" href={encodeURI('/mounts' + path + item.name)} download={item.name}>.</a> }
										{ path !== '/' && (item.type === "directory" ?
											<div className="delete" onClick={(e) => { setActive(i); setPopupDeleteFolder(true); e.stopPropagation()}}/>
											:
											<div className="delete" onClick={(e) => { setActive(i); setPopupDeleteFile(true); e.stopPropagation()}}/>)}
									</div>
								</div>
							</div>
						))}
					</div>

					{/* Popup Create Folder */}
					<div className={"overlay " + (!popupCreateFolder ? '' : 'show')}>
						<div className="popup create-folder" tabIndex={0} onKeyDown={e => {if (e.key === 'Enter') onCreateFolderClick(); }}>
							<div className="close" onClick={()=> setPopupCreateFolder(!popupCreateFolder)}></div>
							<h3>Create Folder</h3>
							<input type="text" placeholder="Folder Name" id="mkdirTextInput" value={mkdirPath} onChange={e => setMkdirPath(e.target.value)}/>

							<div className="button cancel" onClick={() => { setPopupCreateFolder(false)}}>Cancel</div>
							<div className="button delete" onClick={onCreateFolderClick}>Create</div>
						</div>
					</div>

					{/* Popup Upload File */}
					<div className={"overlay " + (!popupUploadFile ? '' : 'show')}>
						<div className="popup">
							<h3>{"Uploading " + `${uploadFileName}...`}</h3>
							<div className="upload-progress-bar">
								<div className={"progress"}></div>
							</div>

							<div className="button ok" onClick={() => {
									controllerRef.current?.abort(); 
								}}>Cancel</div>
						</div>
					</div>

					{/* Popup Delete Folder */}
					<div className={"overlay " + (!popupDeleteFolder ? '' : 'show')}>
						<div className="popup">
							<div className="close" onClick={()=> setPopupDeleteFolder(!popupDeleteFolder)}></div>
							<h3>Delete Folder?</h3>
							<p>Do you want to delete
							<span>
								{list.filter(item => item.id === active).map((item, i) => (
									<span> {item.name}</span>
								))}
							</span>?</p>

							<div className="button cancel"onClick={()=> setPopupDeleteFolder(false)}>Cancel</div>
							<div className="button delete" onClick={() => { deleteItem(list[active]); setPopupDeleteFolder(false)}}>Delete</div>
						</div>
					</div>

					{/* Popup Delete File */}
					<div className={"overlay " + (!popupDeleteFile ? '' : 'show')}>
						<div className="popup">
							<div className="close" onClick={()=> setPopupDeleteFile(!popupDeleteFile)}></div>
							<h3>Delete File?</h3>
							<p>Do you want to delete this file 
							<span>
								{list.filter(item => item.id === active).map((item, i) => (
									<span> {item.name}</span>
								))}
							</span>?</p>

							<div className="button cancel" onClick={()=> setPopupDeleteFile(false)}>Cancel</div>
							<div className="button delete" onClick={() => { deleteItem(list[active]); setPopupDeleteFile(false)}}>Delete</div>
						</div>
					</div>

					{/* Popup Error Message */}
					<div className={"overlay " + (!popupError ? '' : 'show')}>
						<div className="popup">
							<div className="close" onClick={()=> setPopupError(!popupError)}></div>
							<h3 className="error">Error</h3>
							<p>{currentError}</p>

							<div className="button ok" onClick={()=> setPopupError(!popupError)}>Ok</div>
						</div>
					</div>

					{/* Popup Existing File Message */}
					<div className={"overlay " + (!popupExistingFile ? '' : 'show')}>
						<div className="popup">
							<div className="close" onClick={()=> resetUploadInput(uploadInput)}></div>
							<h3>Uploading existing file(s)</h3>
							<p>Do you want to overwrite existing file(s) anyway?</p>
							<div className="button cancel" onClick={()=> resetUploadInput(uploadInput)}>Cancel</div>
							<div className="button delete" onClick={()=> processUploadInput(uploadInput)}>Overwrite</div>
						</div>
					</div>

				</Container>
			</AppWrapper>
		</>
	);
}

export default App;
